import { useScrollAnimationSection } from '../../../hooks/useScrollAnimation';

interface CTASectionProps {
  onOpenModal: () => void;
}

const featuredArticles = [
  {
    id: 7,
    icon: 'ri-flag-line',
    title: '鳥取で家づくりは何から始める？初心者が最初にやるべき5ステップ',
    tag: 'まず読む',
    tagColor: '#8FA882',
  },
  {
    id: 41,
    icon: 'ri-money-yen-circle-line',
    title: '初心者でもわかる！住宅ローンの選び方・審査のコツ',
    tag: '人気',
    tagColor: '#C8956A',
  },
  {
    id: 27,
    icon: 'ri-calculator-line',
    title: '鳥取で家を買う頭金はいくら必要？ゼロでも買えるのか徹底解説',
    tag: '初心者向け',
    tagColor: '#6A8AA0',
  },
];

export default function CTASection({ onOpenModal }: CTASectionProps) {
  const sectionRef = useScrollAnimationSection();

  return (
    <section
      id="cta"
      ref={sectionRef}
      className="py-24 md:py-32 relative overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/4b6a5e8663f506730fa3f311ba909cf5.jpg"
          alt=""
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-[#5A7A52]/88" />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-12 fade-in-up">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/20 text-white/90 text-xs font-semibold tracking-wide mb-5 backdrop-blur-sm border border-white/20">
            <i className="ri-book-open-line" />
            最初の一歩
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white leading-tight mb-4">
            まずはこの記事から<br />読んでみてください
          </h2>
          <p className="text-white/80 text-base leading-relaxed max-w-md mx-auto">
            住宅購入に必要な知識を、ステップごとにまとめた記事です。<br className="hidden md:block" />
            まずここから読むと、全体像がつかめます。
          </p>
        </div>

        {/* Featured Article Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10">
          {featuredArticles.map((art, i) => (
            <a
              key={art.title}
              href={`/articles/${art.id}`}
              className="fade-in-up bg-white/95 backdrop-blur-sm rounded-2xl p-5 cursor-pointer hover:-translate-y-1 transition-transform duration-300 group no-underline"
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#E8F0E6] flex-shrink-0">
                  <i className={`${art.icon} text-[#6A9060] text-base`} />
                </div>
                <span
                  className="px-2.5 py-0.5 rounded-full text-white text-[10px] font-bold mt-1"
                  style={{ backgroundColor: art.tagColor }}
                >
                  {art.tag}
                </span>
              </div>
              <h4 className="text-[#2C2C2C] text-sm font-semibold leading-snug group-hover:text-[#8FA882] transition-colors">
                {art.title}
              </h4>
              <div className="flex items-center gap-1 text-[#8FA882] text-xs font-semibold mt-3">
                <span>記事を読む</span>
                <i className="ri-arrow-right-line" />
              </div>
            </a>
          ))}
        </div>

        {/* Main CTA Button */}
        <div className="fade-in-up text-center">
          <a
            href="#articles"
            className="inline-flex items-center gap-3 px-10 py-4 rounded-full bg-white text-[#5A7A52] font-bold text-base hover:bg-[#F0EBE3] transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-article-line text-lg" />
            すべての記事を見る
            <i className="ri-arrow-right-line" />
          </a>


          {/* Secondary CTA */}
          <div className="mt-8 inline-block">
            <div className="h-px w-16 bg-white/30 mx-auto mb-6" />
            <p className="text-white/70 text-sm mb-4">記事を読んで気になったら、まず資料請求から</p>
            <button
              onClick={onOpenModal}
              className="inline-flex items-center gap-2.5 px-10 py-4 rounded-full bg-[#D4A96A] text-white font-bold text-base hover:bg-[#C09050] transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-file-list-3-line text-lg" />
              資料請求はこちら（無料）
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
